import React from 'react'
import './style.scss'
import { Outlet } from 'react-router-dom';
import Filter from '../../generic/filter/Filter'

const DashboardPage = () => {

  return (

    <div className='dashboard'>
      <div className='dashboard__filter'>
        <Filter />
      </div>
      <div className='dashboard__main'>
        <Outlet />
      </div>
    </div>
  )
}

export default DashboardPage;
